import { render } from "./gmRecharge.vue?vue&type=template&id=4252bb74&scoped=true"
import script from "./gmRecharge.vue?vue&type=script&lang=js"
export * from "./gmRecharge.vue?vue&type=script&lang=js"

import "./gmRecharge.vue?vue&type=style&index=0&id=4252bb74&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4252bb74"

export default script